'<template>
   <div class="page_list_container">
      <div class="list_titlebox">
         <h5>直播培训</h5>
      </div>
      <div class="list_navigation max_width">
         当前位置：<router-link to="/">首页 -</router-link> <a>直播培训</a>
      </div>
      <div class="list_content">
         <div class="max_width">
            <div class="list_left">
               <div class="left_nav">
                  <div class="l_nav_item active">
                     <router-link to="/live">
                        直播 <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
                 <!-- <div class="l_nav_item">
                     <router-link to="/">
                        回放 <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>-->
               </div>
            </div>
            <div class="list_right">
               <div class="right_livelist">
                  <ul>
                     <li v-for="(item,index) in list">
                        <div class="imgbox">
                           <router-link :to="'/live/info/'+item.code"><img :src="item.photo" alt=""></router-link>
                        </div>
                        <div class="right_info">
                           <h5>
                              <router-link :to="'/live/info/'+item.code">{{item.title}}</router-link>
                           </h5>
                           <div class="right_date">
                              <div class="date_col">
                                 <span>讲师：{{item.lecturer != null ?item.lecturer:'--'}}</span>
                              </div>
                              <div class="date_col">
                                 <span>时间：{{item.beginTime}} - {{item.endTime}}</span>
                              </div>
                              <div class="date_col">
                                 <span>&nbsp;</span>
                                  <!--type1 直播中 type2 未开播-->
                                 <span class="status" :class="[item.liveStatus == 5?'type1':'',item.liveStatus == 9?'type2':'',item.liveStatus == 1?'type2':'']">{{item.liveStatusName}}</span>
                              </div>
                           </div>
                        </div>
                     </li>
                  </ul>
               </div>
               <div class="list_pages">
                  <el-pagination layout="prev, pager, next" :page-size="pageSize" :total="pagecount">
                  </el-pagination>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>


<script>
   import {tongji } from '@/assets/js/tongji.js'; // 时间倒计时
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'list_page',
      components: {
         tongji
      },
      data() {
         return {
            loading:true,
            pageNum: 1,
            pageSize: 10,
            pagecount: 10,
            list:[],
         };
      },
      mounted() {
         this.getlist();
      },
      methods: {
         getlist() {
            var _this = this;
            _this.$api.liveList({
               pageNum: _this.pageNum,
               pageSize: _this.pageSize
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.list = res.data.list;
                  _this.pagecount = res.data.total;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
         handleCurrentChange(val) {
            this.pageNum = val;
            this.getlist();
         },
         status_show(item){
            if(item.status == 1){

            }
         }
      }
   }
</script>
<style lang="less" scoped>

</style>
